export default __webpack_public_path__ + "static/media/leadtime.d2453d7d.svg";